import React, { useContext, useEffect, useState } from "react";
import { useIntl } from "react-intl";

import LevelGraphStructure from "../GraphStructure/LevelGraphStructure";
import {
  getDashboardQueryParams,
  getLocalizedMessage,
} from "../../../../UtilityFunctions/utils";
import variables from "../../../../themes/base/styles/variables";
import { OneRow } from "../../../../core/layouts";
import DashboardService from "../../../../services/dashboard-service";
import { DashboardContext } from "../../../../globalContext/dashboard/dashboardProvider";
import {
  getCountLevel,
  setLevel2Graph,
} from "../../../../globalContext/dashboard/dashboardActions";
import { BAD_REQUEST } from "../../../../constants/errorConstants";
import { GlobalLoaderContext } from "../../../../globalContext/globalLoader/globalLoaderProvider";
import { AuthContext } from "../../../../globalContext/auth/authProvider";
import { userRole } from "../../../../constants";

export const Level2Styles = {
  spinner: {
    justifyContent: variables.alignCenter,
  },
};

const Level2 = ({ filter }) => {
  const intl = useIntl();
  const [dashboardState, dashboardDispatch] = useContext(DashboardContext);
  const [level2Data, setLevel2Data] = useState([]);
  const [dataNotFound, setDataNotFound] = useState("");
  const [checked, setChecked] = useState(false);
  const [authState] = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const loaderDispatch = useContext(GlobalLoaderContext)[1];

  useEffect(() => {
    setIsLoading(true);
    let params = getDashboardQueryParams(filter);
    delete params.isPercentage;
    if (
      !params.year ||
      (params.type === "Repair" && !params.subProductCategoryId) ||
      (authState?.currentRole?.id === userRole.ADMIN && !params.countryId) ||
      !params.type
    ) {
      setDataNotFound(
        getLocalizedMessage(
          intl,
          authState?.currentRole?.id !== userRole.ADMIN
            ? "selectCategories.CA.TM.label"
            : "selectCategories.label"
        )
      );
    } else {
      if (dataNotFound) {
        setDataNotFound("");
      }
      DashboardService.getCountLevelApiCall({
        dispatch: dashboardDispatch,
        intl,
        params: {
          ...params,
          level: 2,
        },
        action: getCountLevel,
      })
        .then((data) => {
          dashboardDispatch(setLevel2Graph(data.data));
        })
        .catch((error) => {
          if (error?.response?.data?.code === BAD_REQUEST) {
            setDataNotFound(
              getLocalizedMessage(intl, "dataNotAvailable.label")
            );
          }
        });
    }
    setIsLoading(false);
  }, [filter]);

  useEffect(() => {
    if (dashboardState.level2.result) {
      const newData = dashboardState?.level2?.result?.map((item, index) => ({
        name: dashboardState.level2.result[index].sectionName,
        okCount: dashboardState.level2.result[index].okCount,
        questionCount: dashboardState.level2.result[index].questionCount,
        percentage: dashboardState.level2.result[index].percentage,
      }));
      setLevel2Data(newData);
    }
  }, [dashboardState]);

  useEffect(() => {
    setIsLoading(true);
    if (checked) {
      const convertedData = level2Data?.map((item) => {
        return {
          ...item,
          percentage: (item.okCount / item.questionCount) * 100,
          okCount: item.percentage,
          questionCount: 100,
        };
      });
      setLevel2Data(convertedData);
    } else {
      const newData = dashboardState?.level2?.result?.map((item, index) => ({
        name: dashboardState.level2.result[index].sectionName,
        okCount: dashboardState.level2.result[index].okCount,
        questionCount: dashboardState.level2.result[index].questionCount,
        percentage: dashboardState.level2.result[index].percentage,
      }));
      setLevel2Data(newData);
    }
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, [checked]);

  const modifiedData = level2Data?.map((item) => {
    return {
      ...item,
      remainingCount: item.questionCount - item.okCount,
    };
  });

  const downloadUserReportsHandler = () => {
    let queryParams = getDashboardQueryParams(filter);
    delete queryParams.isPercentage;
    DashboardService.dashboardDownloadReportApiCall({
      params: {
        ...queryParams,
        fileName: getLocalizedMessage(intl, "dashboard.level2.label"),
        reportType: getLocalizedMessage(intl, "levelReport.label"),
        level: 2,
      },
      intl,
      loaderDispatch: loaderDispatch,
    });
  };

  return (
    <OneRow
      id="level2-graph"
      section={
        <LevelGraphStructure
          dataNotFound={dataNotFound}
          setDataNotFound={setDataNotFound}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          data={modifiedData}
          legend1={getLocalizedMessage(intl, "levelGraphs.legend1.label")}
          legend2={getLocalizedMessage(intl, "levelGraphs.legend2.label")}
          dataKey1={getLocalizedMessage(intl, "remainingCount.label")}
          dataKey2={getLocalizedMessage(intl, "okCount.label")}
          dataKey3={getLocalizedMessage(intl, "name.label")}
          dataKey4="questionCount"
          checked={checked}
          setChecked={setChecked}
          downloadUserReportsHandler={downloadUserReportsHandler}
          labelText={getLocalizedMessage(intl, "dashboard.level2.label")}
          text1={getLocalizedMessage(intl, "levelGraph.payload.value1")}
          text2={getLocalizedMessage(intl, "levelGraph.payload.value2")}
          linkLabel={getLocalizedMessage(intl, "level2.link.label")}
          background={{ fill: `${variables.lightPurple}` }}
          color1={variables.darkViolet}
          color2={variables.lightPurple2}
          isPercentageChecked={checked}
          level={"LEVEL2"}
          graphId={"level2-graph"}
        />
      }
    />
  );
};

export default Level2;
